import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface UpdateAttendanceParam {
  classId: string;
  student: string;
  date: string;
  attendanceId: string;
  status: 'present' | 'absent';
}

export const updateAttendanceAPI = async (
  attendanceDetails: UpdateAttendanceParam,
) => {
  const resp = await baseAPI.post<unknown>('/attendance', attendanceDetails);
  return resp.data;
};

export const useUpdateAttendanceMutation = () => {
  return useMutation({
    mutationFn: async (attendanceDetails: UpdateAttendanceParam) => {
      const response = await updateAttendanceAPI(attendanceDetails);
      return response;
    },
    onSuccess: (_, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ATTENDANCE, variables.classId, variables.date],
      });
    },
    onSettled: (_, __, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ATTENDANCE, variables.classId, variables.date],
      });
    },
  });
};
